// Map the saved /live/config strategy to backtesting query parameters.
// Execution controls and fees have different semantics and are not inferred.
export function settingsFromLive(config) {
  if (!config) throw new Error("LiveTesting settings are unavailable.");
  const number = (key, nullable = false) => {
    const value = config[key];
    if (value == null && nullable) return null;
    if (value == null || value === "" || !Number.isFinite(Number(value))) {
      throw new Error(`Invalid LiveTesting setting: ${key}`);
    }
    return Number(value);
  };
  const params = {};
  ["buy_floor", "buy_floor_mid", "buy_floor_long", "buy_lead_split1", "buy_lead_split2",
    "sell_floor", "buy_margin", "sell_margin", "anchor_tol"].forEach((key) => {
    params[key] = number(key);
  });
  if (params.anchor_tol < 0 || params.anchor_tol > 24) {
    throw new Error("LiveTesting anchor tolerance exceeds the stored backtest book range (0–24 EUR).");
  }
  params.lead_min = number("lead_min_min");
  params.lead_max = number("lead_max_min");
  const drop = number("sell_margin_drop", true);
  const rise = number("sell_margin_rise", true);
  const trend = {
    enabled: drop !== null || rise !== null,
    sell_margin_drop: drop,
    sell_margin_rise: rise,
    sell_dpred_drop: number("sell_dpred_drop"),
    sell_dpred_rise: number("sell_dpred_rise"),
  };
  const guards = {};
  ["buy_subres", "buy_reserve", "sell_subzrb"].forEach((key) => {
    if (typeof config[`guard_${key}_on`] !== "boolean") {
      throw new Error(`Invalid LiveTesting guard: ${key}`);
    }
    guards[key] = { enabled: config[`guard_${key}_on`], value: number(`guard_${key}`) };
  });
  return { params, trend, guards };
}
